import { render, staticRenderFns } from "./byu.vue?vue&type=template&id=55791488&"
import script from "./byu.vue?vue&type=script&lang=js&"
export * from "./byu.vue?vue&type=script&lang=js&"
import style0 from "./byu.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports